import React from 'react'
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText'
import Button from './Button'
import Heading from './Heading'
import GetAny from '/src/utils/GetAny'
import FluidImage from '/src/utils/FluidImage'
import ContentLabel from './ContentLabel'
import ShortenText from 'src/utils/ShortenText'

const TwoColumnCards = ({blok}) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
    <div className="bg-white mt-16 mb-20 lg:mt-24 lg:mb-28">
      <div className="relative mx-auto divide-y divide-gray-200 max-w-7xl lg:px-8 px-6">
        {blok.title && blok.description &&
            <div className={`${blok.hide_description && blok.button_target.cached_url ? "mb-6" : ""} flex lg:flex-row flex-col lg:justify-between lg:items-end gap-y-4`}>
                <div>
                    {blok.title && <Heading size="h2" className="text-darkgrey mb-2">{blok.title}</Heading>}
                    {!blok.hide_description &&
                        <div className="text-darkgrey prose text-sm">
                            <RichText>{blok.description}</RichText>
                        </div>
                    }
                </div>
                {blok.button_target.cached_url &&
                    <div>
                        <Button target={`${blok.button_target.cached_url}`} className="bg-red hover:bg-darkred">{blok.button_text}</Button>
                    </div>
                }
            </div>
        }
        <div className={`${!blok.hide_description ? "mt-6 pt-10" : "mt-0 " } grid gap-12 lg:grid-cols-2 lg:gap-x-8 lg:gap-y-12`}>
          {GetAny(blok.posts).map((post) => (
            <div key={post.name} className="group cursor-pointer relative">
                {!blok.hide_tags &&
                    <div className="absolute top-0 left-0 z-10">
                        <ContentLabel type={post.content.component} />
                    </div>
                }
                <a href={`/${post.full_slug}`} className="block">
                <FluidImage image={post.content.featured_image} className={`object-cover hover:opacity-70 duration-300`} alt={post.name}/>
                    <Heading size="h4" className="text-darkgrey mb-0 mt-6 !leading-7">{post.name}</Heading>
                    <div className="mt-4 text-sm text-darkgrey">
                        {ShortenText(post.content.description)}
                    </div>
                </a>
                {blok.show_buttons &&
                    <div className="mt-6">
                        <Button target={`${post.full_slug}`} className="bg-red group-hover:bg-darkred">Find out more</Button>
                    </div>
                }
            </div>
          ))}
        </div>
      </div>
    </div>
    </SbEditable>
  )
};

export default TwoColumnCards;
